import { RouteDto, RouteSaveDto } from "../models/route/route";
import { apiCall } from "./apiClient";

export const getRoutes = async(onlyActive: boolean = true, signal?: AbortSignal) => {
    const response = await apiCall<RouteDto[]>(`Routes?onlyActive=${onlyActive}`, "GET", null, signal);
    return response.data;
};

export const getRoute = async(id: string) => {
    const response = await apiCall<RouteDto>(`Routes/${id}`, "GET");
    return response.data;
};

export const saveRoute = async(data: RouteSaveDto) => {
    const response = await apiCall<RouteDto>("Routes", "POST", data);
    return response.data;
};

export const deleteRoute = async(id: string) => {
    return await apiCall<void>(`Routes/${id}`, "DELETE");
};
